// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import Widget from '@arcgis/core/widgets/Widget';
import { tsx } from '@arcgis/core/widgets/support/widget';

import MapView from '@arcgis/core/views/MapView';
import SceneView from '@arcgis/core/views/SceneView';

import '@esri/calcite-components/dist/calcite/calcite.css';

interface AreaProps {
  view: MapView | SceneView;

}

class TerrainWidget extends Widget {
  view: MapView | SceneView;

  isActive = false;

  constructor(params: AreaProps) {
    super(params);
    this.view = params.view;
  }

  _handleClick() {
    if (!this.isActive) {
      this.isActive = true;
    } else {
      this.isActive = false;
    }
    this.emit('terrain-toggle', { active: this.isActive });
  }

  render() {
    return tsx(
      'div',
      {
        class: 'esri-widget esri-widget--button',
        style: 'cursor:pointer',
        onclick: this._handleClick.bind(this),
      },
      tsx('calcite-icon', {
        icon: this.isActive ? 'x' : 'hide-layers',
        title: this.isActive ? 'Hide Terrain' : 'Show Terrain',
      }),
    );
  }
}

export default TerrainWidget;
